var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stat-graphic-type-2"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.valori.data),function(valore){return (_vm.valori.data)?_c('Grafico2Valore',{attrs:{"value":valore}}):_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }